import {
    Button,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
} from "@material-ui/core";
import {
    Add,
} from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { showAddItemCategoriesDialog } from "../item-categories-add/item-categories-add-slice";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
        background: "#111111",
        height: "100%",
        color: "#fbbbd3",
        fontSize: 14,
    },
    button: {
        background: "#111111",
        color: "#fbbbd3",
        justifyContent: "right",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        color:"#111111",
        marginBottom: 20,
    },
    typography: {
        color:"#111111",
    }
}));

const ItemCategoriesListEmpty = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const handleAddOpen = () => {
        dispatch(showAddItemCategoriesDialog());
    };

    return (
        <>
            <Typography className={classes.title} variant="h4">Item Categories</Typography>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 10}}>
                <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<Add/>}
                    onClick={handleAddOpen}
                >
                    Add
                </Button>
            </div>

            <TableContainer component={Paper}>
                <Table aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left" className={classes.tableHeader}>Code</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Name</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Description</TableCell>
                            <TableCell align="left" className={classes.tableHeader}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                </Table>
            </TableContainer>
            <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                <Typography className={classes.typography}>
                    No categories found.
                </Typography>
            </div>
        </>
    )
};

export default ItemCategoriesListEmpty;